import * as React from "react";

export type VersionActionBtnProps = {
  title: string;
  onClick: () => void;
  children: React.ReactNode;
  /** Slightly smaller hit target for revision rows */
  compact?: boolean;
  disabled?: boolean;
};

export const VersionActionBtn: React.FC<VersionActionBtnProps> = ({
  title,
  onClick,
  children,
  compact,
  disabled,
}) => (
  <button
    type="button"
    title={title}
    aria-label={title}
    disabled={disabled}
    onClick={(e) => {
      e.stopPropagation();
      if (!disabled) onClick();
    }}
    className={`versions-action-btn${compact ? " versions-action-btn--compact" : ""}`}
  >
    {children}
  </button>
);
